import { useState, useEffect } from 'react';
import { useGetGeoLocation } from '@/modules/Customer/http/client/useGetGeoLocation';
import { getCookie, setCookie } from '@/utils/cookies';
type GeoData = {
  ip?: string;
  city?: string;
  region?: string;
  country?: string;
};
const useGeoLocation = () => {
  const [geoData, setGeoData] = useState<GeoData | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [hasGeoData, setHasGeoData] = useState<boolean>(false);
  const {
    data,
    isError
  } = useGetGeoLocation();
  useEffect(() => {
    const cookieGeoData = getCookie('geoData');
    if (cookieGeoData) {
      setGeoData(JSON.parse(cookieGeoData));
      setHasGeoData(true);
      return;
    }
    if (data) {
      const geoData = {
        ip: data?.ip || data?.IPv4,
        city: data?.city,
        region: data?.region_code || data?.region || data?.state,
        country: data?.country || data?.country_code || data?.country_name
      };
      setGeoData(geoData);
      setCookie('geoData', JSON.stringify(geoData));
      setHasGeoData(true);
    }
    if (isError) {
      setError('Failed to fetch geolocation data');
    }
  }, [data, isError]);
  return {
    geoData,
    error,
    hasGeoData
  };
};
export default useGeoLocation;